/**
 * Payment System Types
 * Types for invoices, payments, refunds, and provider accounts
 */
// ============================================
// ENUMS - Mirror Prisma schema enums
// ============================================
export var PaymentProvider;
(function (PaymentProvider) {
    PaymentProvider["STRIPE"] = "STRIPE";
    PaymentProvider["PAGSEGURO"] = "PAGSEGURO";
    PaymentProvider["MERCADOPAGO"] = "MERCADOPAGO";
    PaymentProvider["MANUAL"] = "MANUAL";
})(PaymentProvider || (PaymentProvider = {}));
export var InvoiceStatus;
(function (InvoiceStatus) {
    InvoiceStatus["DRAFT"] = "DRAFT";
    InvoiceStatus["OPEN"] = "OPEN";
    InvoiceStatus["PARTIALLY_PAID"] = "PARTIALLY_PAID";
    InvoiceStatus["PAID"] = "PAID";
    InvoiceStatus["OVERDUE"] = "OVERDUE";
    InvoiceStatus["CANCELED"] = "CANCELED";
})(InvoiceStatus || (InvoiceStatus = {}));
export var InvoiceLineItemType;
(function (InvoiceLineItemType) {
    InvoiceLineItemType["ENROLLMENT"] = "ENROLLMENT";
    InvoiceLineItemType["PRODUCT"] = "PRODUCT";
    InvoiceLineItemType["SERVICE"] = "SERVICE";
    InvoiceLineItemType["DISCOUNT"] = "DISCOUNT";
    InvoiceLineItemType["CREDIT"] = "CREDIT";
    InvoiceLineItemType["FEE"] = "FEE";
})(InvoiceLineItemType || (InvoiceLineItemType = {}));
export var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["PENDING"] = "PENDING";
    PaymentStatus["PROCESSING"] = "PROCESSING";
    PaymentStatus["SUCCEEDED"] = "SUCCEEDED";
    PaymentStatus["PARTIALLY_REFUNDED"] = "PARTIALLY_REFUNDED";
    PaymentStatus["REFUNDED"] = "REFUNDED";
    PaymentStatus["CHARGEBACK_PENDING"] = "CHARGEBACK_PENDING";
    PaymentStatus["CHARGEBACK_LOST"] = "CHARGEBACK_LOST";
    PaymentStatus["FAILED"] = "FAILED";
    PaymentStatus["CANCELED"] = "CANCELED";
})(PaymentStatus || (PaymentStatus = {}));
export var RefundStatus;
(function (RefundStatus) {
    RefundStatus["PENDING"] = "PENDING";
    RefundStatus["SUCCEEDED"] = "SUCCEEDED";
    RefundStatus["FAILED"] = "FAILED";
})(RefundStatus || (RefundStatus = {}));
export var ReconciliationStatus;
(function (ReconciliationStatus) {
    ReconciliationStatus["PENDING"] = "PENDING";
    ReconciliationStatus["MATCHED"] = "MATCHED";
    ReconciliationStatus["UNMATCHED"] = "UNMATCHED";
    ReconciliationStatus["RESOLVED"] = "RESOLVED";
})(ReconciliationStatus || (ReconciliationStatus = {}));
// Payment methods - used for both manual and PSP payments
export var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod["CREDIT_CARD"] = "CARD";
    PaymentMethod["DEBIT_CARD"] = "DEBIT_CARD";
    PaymentMethod["PIX"] = "PIX";
    PaymentMethod["BOLETO"] = "BOLETO";
    PaymentMethod["CASH"] = "CASH";
    PaymentMethod["BANK_TRANSFER"] = "BANK_TRANSFER";
    PaymentMethod["OTHER"] = "OTHER";
})(PaymentMethod || (PaymentMethod = {}));
/**
 * @deprecated Use PaymentMethod instead
 */
export const ManualPaymentMethod = PaymentMethod;
//# sourceMappingURL=Payment.js.map